<template>
    <div class="main-container">
        <header class="header" :class="{ 'fixed-header': isFixed }">
            <div class="header-logo-container">
                <img :src="require('@/assets/logo-hbcard-25.png')" alt="">
            </div>
            <div class="header-button-container">
                <div class="button header-button"
                @click="irParaPrecos"
                >
                Clique aqui e adquira já
            </div>
            </div>
        </header>


        <section class="home-section">

            <div class="info-container">
                <div class="h1-container">
                    <p class="h2-text">Cansado de filas e demora para ser atendido por um médico?
                        Tenha acesso IMEDIATO a PRONTO ATENDIMENTO 24hs, ginecologistas, pediatras, psicólogos, nutricionistas e muito mais - tudo por:</p>
                    <h1 class="h1-price">R$ {{ planos[0].price.toFixed(2).replace('.', ',') }} 
                        <br> mensal
                    </h1>
                    
                </div>
               
                <div class="button home-button"
                @click="irParaPrecos">
                    Clique aqui e agende suas consultas
                </div>
            </div>

            <div class="img-container">
                <img :src="require('@/assets/homeImg.png')" alt="homeImg">
            </div>
        </section>

        <br>

        <section class="section-produto">
            <div class="produto-header">
                <div class="produto-title">
                    <p>Cuide da sua saúde de qualquer lugar</p>
                    <h3 style="text-align: left; color: #082777;">Com a gente você escolhe onde quer ser atendido, levamos o médico até você de maneira 100% online. Você pode escolher entre consultas por chamadas de vídeo, chamada de voz ou via chat. Isso tudo no conforto da sua casa, no seu trabalho, numa viagem em família ou onde você preferir.</h3>
                </div>
            </div>
            <div class="produto-info">
                <div class="produto-itens-container">
                    <div class="list-container">
                       <div class="list-item">
                            <span class="material-symbols-outlined">
                             emergency
                            </span>
                            <p>Pronto atendimento 24h com clínico geral</p>
                       </div>
                       <div class="list-item">
                            <span class="material-symbols-outlined">
                             emergency  
                            </span>
                            <p>Atendimento em até 10min com pediatra, ginecologista, médico veterinário, pedido de exames e receituário médico</p>
                       </div>
                       <div class="list-item">
                            <span class="material-symbols-outlined">
                             emergency
                            </span>
                            <p>Ou agende com dermatologista, nutricionista, psicólogo ou personal trainer</p>
                       </div>
                       <div class="list-item">
                            <span class="material-symbols-outlined">
                             emergency
                            </span>
                            <p>100% online no conforto do seu lar ou trabalho</p>
                       </div>

                    </div>
                    <div class="buton-container">
                        <div class="button button-produto"
                        @click="irParaPrecos">
                            ASSINE AGORA
                        </div>
                    </div>
                </div>

                <div class="produto-video-container video">
                    <img :src="require('@/assets/agenda.png')" alt="Agenda" style="max-width: 300px;min-width: 225px;">
                </div>
            </div>



        </section>

        <br>

        <section class="section-produto tokio">
            <div class="produto-header">
                <div class="produto-title">
                    <p>Economize tempo e dinheiro</p>
                </div>
            </div>
            <div class="produto-info">
                <div class="produto-itens-container">
                    <div class="info-container">
                <div class="h1-container">
                    <p class="h2-text">Evite filas de esperas, risco de contaminação em hospitais, burocracias e trânsitos caóticos. Garanta agora mesmo para você e para a sua família saúde de qualidade de onde estiver!</p>
                    <p class="h2-text">Assista ao lado o recado que temos para você!</p>
                    <h1 class="h1-price h1-price-produto">70% OFF</h1>
                </div>

                    </div>
                    <div class="buton-container">
                        <div class="button button-produto"
                        @click="irParaPrecos">
                            ASSINE AGORA
                        </div>
                    </div>
                </div>

                <div class="produto-video-container ">
                    <video controls>
                        <source :src="require('@/assets/video-landing.mp4')" type="video/mp4">
                        Your browser does not support the video tag.
                    </video>
                </div>
            </div>



        </section>

        <h1 class="faq-title">Também cuidamos da sua família</h1>


        <section class="section-auxilio">
           
            <div class="auxilio-card">
                <div class="auxilio-card-header">
                    <div class="icon-container">
                        <span class="material-symbols-outlined">
                            family_restroom
                        </span>
                    </div>

                    <div class="auxilio-card-label">
                        Bônus
                    </div>
                </div>
                    <div class="auxilio-card-text">
                        Inclua todos os filhos até 18 anos gratuitamente
                    </div>
            </div>

            <div class="auxilio-card">
                <div class="auxilio-card-header">
                    <div class="icon-container">
                        <span class="material-symbols-outlined">
                            people
                        </span>
                    </div>

                    <div class="auxilio-card-label">
                        Inclua seu cônjugue com 30% de desconto
                    </div>
                </div>
                    <div class="auxilio-card-text">
                        Por apenas R$ 39,90 mensais
                    </div>
            </div>

            <div class="auxilio-card">
                <div class="auxilio-card-header">
                    <div class="icon-container">
                        <span class="material-symbols-outlined">
                            pets
                        </span>
                    </div>

                    <div class="auxilio-card-label">
                        Medicina veterinária
                    </div>
                </div>
                    <div class="auxilio-card-text">
                        Para você que ama seu bichinho nós oferecemos também a inclusão do seu pet gratuitamente (cães e gatos).
                    </div>
            </div>
        </section>

        <div class="header-button-container">
                <div class="button header-button"
                @click="irParaPrecos"
                >
                Clique aqui e adquira já
            </div>
        </div>

        <section class="faq-section">

            <div class="faq-header">
                <h1 class="faq-title"> Dúvidas Frequentes</h1>
            </div>
            <div class="faq-container"
            v-for="(item, index) in faq" :key="index">
                <LandingPageFaq
                :label="item.label"
                :text="item.text"
                />
            </div>
        </section>

        <section class="section-depoimentos">
            <h1 class="faq-title"> Depoimentos dos clientes</h1>

            <div class="depoimento-container"
            v-for="(depoimento, index) in depoimentos" :key="index">
                <LandingPageDepoimentoCard
                :img="depoimento.img"
                :nome="depoimento.nome"
                :text="depoimento.text"
                />
            </div>
        </section>

        <section class="video-einstein">
            <div class="video-einstein-container">
                <img :src="require('@/assets/banner-hbcard.png')" alt="Banner Hbcard" style="width: 100%; height: auto;">
            </div>
        </section>

        <div class="here"></div>
        
        <section class="preços">
            <div class="card-container"
            v-for="(plano, index) in planos" :key="index"
            >
                <LandingPageCardPrecos
                :title="plano.title"
                :users="plano.users"
                :einsteinPrice="plano.einsteinPrice"
                :price="plano.price"
                :push="plano.push"
                />
            </div>
            <div class="contact-details h2-text">
                <h2>Entre em Contato</h2>
                <p>
                    <span class="material-symbols-outlined" style="vertical-align: middle; margin-right: 5px;">
                        phone
                    </span>
                    Telefones: 
                    <a href="tel:+558231420773">(82) 3142-0773</a> / 
                    <a href="tel:+5582999353701">(82) 99935-3701</a>
                </p>
                <p>
                    <i class="fab fa-whatsapp" style="vertical-align: middle; margin-right: 5px;"></i>
                    Whatsapp: <a href="https://api.whatsapp.com/send?phone=5582999976133" target="_blank">
                     (82) 99997-6133
                    </a>
                </p>
                <p>
                    <i class="fab fa-instagram" style="vertical-align: middle; margin-right: 5px;"></i>
                    Instagram: <a href="https://www.instagram.com/saudefacil_hbcard" target="_blank">@saudefacil_hbcard</a></p>
            </div>
        </section>
    </div>
</template>

<script>

import LandingPageFaq from '@/components/LandingPageFaq.vue';
import LandingPageCardPrecos from '@/components/LandingPageCardPrecos.vue';
import LandingPageDepoimentoCard from '@/components/LandingPageDepoimentoCard.vue';

export default {
    data(){
        return{
            planos:[
                // {
                //     einsteinPrice: 99.90,
                //     title: 'Familiar',
                //     price: 29.90,
                //     users: 2,
                //     push:'Familiar'
                // },
                {
                    einsteinPrice: 129.90,
                    title: 'Individual',
                    price: 59.9,
                    users: 0,
                    push:'Individual'
                },
                // {
                //     einsteinPrice: 0,
                //     title: 'Empresarial',
                //     price: 19.90,
                //     users: 10,
                // },
            ],

            isFixed: false,

            faq:[
                {
                    label:'O que é a Saúde fácil HBCard?',
                    text:'A Saúde fácil HBCard é o seu pronto atendimento virtual, disponibilizando diversos especialistas, pelo seu computador, celular ou quaisquer outro dispositivo móvel que você tenha acesso, nele você poderá escolher a especialidade que precisa e o meio que quer ser atendido, chamada de vídeo, chamada de voz ou chat, além de atendimento presencial com mais de 700 médicos renomados.'
                },
                {
                    label:'Quem pode usar?',
                    text:'Qualquer pessoa sem limite de idade mínima ou máxima, e/ou indicada pelo titular da conta sem necessidade de grau de parentesco, sem carência ou doença pré-existente.'
                },
                {
                    label:'Como assinar?',
                    text:'Clicando no link em laranja neste site, ou contate-nos pelo número: <a target="_blank" href="https://api.whatsapp.com/send?phone=+5582999353701"><i class="fab fa-whatsapp"></i> 82 99935 3701</a> ou ligando em <a href="tel:+558231420773"><i class="fa fa-phone"></i> 82 3142 0773</a>.'
                },
                {
                    label:'Tem taxa de adesão?',
                    text:'Sim, apenas no primeiro pagamento você paga a taxa de adesão e a mensalidade, após isso apenas a mensalidade.'
                },
                {
                    label:'Quando posso começar a usar?',
                    text:'Não temos carência, então adquirindo agora e efetuando o pagamento você já pode começar a usar, lembrando que a confirmação do pagamento só é validada em horário comercial.'
                },
            ],

            depoimentos:[
                {
                    img:'yuki.png',
                    nome:'Yuki Toma Giraud, Buenos Aires',
                    text:'Meu nome é Yuki Toma Giraud, tive uma experiência muito positiva com o HBCARD, usando a Telemedicina. Após peregrinar por algumas consultas presenciais que não surgiu nenhum efeito, usei à telemedicina pois estava em Buenos Aires e, o médico solicitou um exame basico(fezes), fiz, mandei p ele no mesmo e-mail e, ele me receitou um remédio, resolvendo um problema que já vinha há mais de 3 meses, onde todos os outros médicos diziam que era virose.',
                },
                {
                    img:'zenilson.png',
                    nome:'Zenilson Oliveira de Lima, Maceió',
                    text:'Sou vendedor e utilizo muito a minha voz, um certo dia minha garganta estava bastante inflamada, e em cinco minutos de atendimento na TELEMEDICINA a médica me examinou, enviou por email o atestado, a receita e ainda mais o resumo da minha consulta. Tudo isso no conforto do meu lar com um atendimento rápido, eficaz e com meu problema solucionado!',
                },
            ],

            iframe:{
                width:854,
                heigth:480,
            },

            vendor_code:''

        }
    },

    methods:{
        irParaPrecos(){
            const precos = document.querySelector('.here')
            precos.scrollIntoView({behavior:'smooth'})
        },

        handleScroll() {
      // Verifica se a posição de rolagem é maior que a posição do cabeçalho
        this.isFixed = window.scrollY > this.$el.querySelector("header").offsetTop;
        },

        updateDimensions(){
            const screenWidth = window.innerWidth

            if (screenWidth < 800){
                this.iframe.width = 240
                this.iframe.heigth = 360
            } else {
                this.iframe.width = 854
                this.iframe.heigth = 480
            }
        },

        verificarCodigoVendedor(){
            if(this.$route.params.vendor_code){
                const vendor_code = this.$route.params.vendor_code
                localStorage.setItem('vendor_code', vendor_code)
                this.vendor_code = vendor_code

                if(this.vendor_code === 'vivianePT'){
                    this.planos[0].price = 40
                    this.planos[1].price = 50

                    this.planos[0].einsteinPrice = 100
                    this.planos[1].einsteinPrice = 130
                }
            }else{
                console.log('não há codigo de vendedor')
                localStorage.setItem('vendor_code', '')
            }
        }
    },

    mounted() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.updateDimensions)

    this.updateDimensions()
    this.verificarCodigoVendedor()
    },


    components:{LandingPageCardPrecos, LandingPageDepoimentoCard, LandingPageFaq}
}
</script>


<style scoped lang="css">

    .main-container{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;
    }

    .header{
        display: flex;
        justify-content: space-between;
        background-color: #fff;
        width: 104%;
        box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);

    }

    .fixed-header {
     position: fixed;
     top: 0;
     width: 100%;
     background-color: white;
     z-index: 1000;
  /* Adicione outros estilos conforme necessário */
    }

    .header-logo-container{
        display: flex;
        align-items: center;
        margin-left: 7%;
        padding: 14px;
        padding-top: 21px;
    }

    .header-logo-container img{
        max-width: 330px;
    }

    .header-button-container{
        display: flex;
        align-items: center;
        margin-right: 7%;
    }

    .header-button{
        height: 55px;
        width: 200px;
    }

    .home-section{
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        height: 80vh;
        width: 100%;
        margin-top: 60px;
    }
    .info-container{
        display: flex;
        flex-direction: column;
    }
    .h1-container{
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;

    }
    .h1-text{
        color:#082777;
        font-size: 50px;
        text-align: left;
        font-weight: bold;

        /* animation: fadeInRight 1s ease-out forwards; */
    }
    .h1-price{
        position: relative;
        top: -60px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 48px;
        padding: 21px;
        padding-bottom: 10px;
        padding-top: 10px;
        padding-right: 35px;
        background-color: #082777;
        color: #ffff;
        border-radius: 12px;
        /* animation: fadeInRight 1s ease-out forwards; */
        box-shadow: 8px 4px 8px rgba(0, 0, 0, 0.1);
    }
    @keyframes fadeInRight {
    /* No início da animação (0%), a opacidade é 0 e a posição X é 100% */
    0% {
        opacity: 0;
        transform: translateX(100%);
    }

    /* No final da animação (100%), a opacidade é 1 e a posição X é 0 */
    100% {
        opacity: 1;
        transform: translateX(0);
    }
    }
    .button{
        display: flex;
        align-items: center;
        justify-content: center;

        background-color: orange;
        border-radius: 12px;
        font-weight: bold;
        color: #ffff;

        box-shadow: 8px 4px 8px rgba(0, 0, 0, 0.1);
        cursor: pointer;


    }
    .home-button{
        /* animation: fadeIn 1.6s ease-out forwards; */

        width: 80%;
        padding-left: 35px;
        padding-right: 35px;
        padding-top: 20px;
        padding-bottom: 20px;

        font-size: 25px;
        position: relative;
        top: -30px;
    }
    @keyframes fadeIn {
    /* No início da animação (0%), a opacidade é 0 */
    0% {
        opacity: 0;
    }

    /* No final da animação (100%), a opacidade é 1 */
    100% {
        opacity: 1;
    }
    }
    .button:hover{
        background-color: #feca62;
    }
    .img-container{
        display: flex;
        align-items: center;
        justify-content: center;

        /* animation: fadeIn 1.8s ease-out forwards; */
       
    }
    .img-container img{
        position: relative;
        top: 47px;
/* 
        /* max-width: 50vw; */
        max-height: 80vh;
    }

    .section-produto{
        display: flex;
        flex-direction: column;
        height: 80vh;
        width: 100%;
        justify-content: center;
        align-items: center;
        margin-top: 200px;
        margin-bottom: 200px;

    
    }

    .produto-header{
        display: flex;
        width: 73%;
    }
    .produto-title p{
        font-weight: bold;
        font-size: 52px;
        color: #082777;
        text-align: left;
    }
    .produto-logo{
        display: flex;
    }
    .produto-logo img{
        max-width: 300px;
    }


    .produto-title{
        width: 70%;
    }

    .list-item{
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: bold;
        font-size: 22px;
        color: #082777;
    }

    .list-item p{
        text-align: left;
        width: 100%;
        margin-left: 20px;
    
    }

    .produto-info{
        display: flex;
        width: 73%;
        justify-content:space-between;
    
    }

    .button-produto{
        width: 350px;
        height: 63px;
    }

    .h2-text{
        color:#082777;
        font-size: 25px;
        text-align: left;
        font-weight: bold;

        /* animation: fadeInRight 1s ease-out forwards; */

        position: relative;
        top: -40px;
    }

    .section-auxilio{
        display: flex;
        margin: 60px;
        background-color: #082777;
        box-shadow: 8px 4px 8px rgba(0, 0, 0, 0.1);
        border-radius: 12px;
        
    }

    .auxilio-card{
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
        color: #fff;
        height: 250px;
        width: 300px;
        margin: 30px;
    }

    .auxilio-card span{
        font-size: 64px;
    }

    .auxilio-card-label{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 50px;
    }

    .auxilio-card-text{
        width: 250px;
    }

    .faq-section{
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin: 60px;
    }

    .faq-header{
        display: flex;
        justify-content: center;
    }
    .faq-title {
        display: flex;
        justify-content: center;
        font-weight: bold;
        font-size: 52px;
        color: #082777;
        text-align: left;
    }

    .section-depoimentos{
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 80%;
    }

    .here{
        height: 10vh;
        margin: 40px;
        background-color: pink;
    }

    .preços{
        
        display: flex;
        /* flex-direction: column; */
        align-items: center;
        justify-content: center;
        height: 80vh;
        margin-top: 60px;
    }




    @media  screen and (max-width: 800px) {

        .header{
            width: 180%;
            flex-direction: column;
            align-items: center;
        }

        .header-logo-container{
            margin: 0;
            padding: 0;
            margin-top: 40px;
        }

        .header-button-container{
            margin-left: 40px;
            margin-bottom: 30px;
        }
        .main-container{
            width: 100%;

        }
         .home-section{
            flex-direction: column;
            margin-top: 200px;
            margin-bottom: 400px;
        }

        .home-button{
            width: 73%;
            margin-left: 2%;
        }

        .h1-container{
            align-items: center;
        }

        .h1-text{
            text-align: center;
        }

        .img-container img{
        position: inline;
        top: 47px;

         max-width: 50vw; 
         max-width: 80%; 
         margin-bottom: 60px;
         }
         

        .section-produto{
            margin-top: 800px;
            align-items: center;
            margin-bottom: 400px;
        }
        .produto-header{
            flex-direction: column;
            text-align: left;

            
        }

        .produto-header p{
            text-align: center;
            /* margin-left: 20%; */
            font-size: 50px;
        } 

        .produto-logo{
            width: 80%;
            align-items: center;
            justify-content: center;
        }

        .produto-logo{
            width: 100%;
            margin: 10px;
            margin-left: 0px;

        }

        .produto-info{
            justify-content: center;
            flex-direction: column;
            margin-bottom: 140px;
        }

        .produto-video-container{
            margin-top: 30px;
            margin-bottom: 300px;
        }

        .produto-title{
            display: flex;
            justify-content: center;
            width: 100%;
        }
        .h2-text{
            top: 0px;
            text-align: center;
            width: 100%;
        }

        .h1-price-produto{
            margin-top: 50px;
            top:-20px;
            margin-left: 2%;
            
        }

        .button-produto{
            margin-top: 20px;
        }

        .buton-container{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            
        }

        .section-auxilio{
            flex-direction: column;
            width: 80%;
            
        }

        .auxilio-card{
            width: auto;
            height: auto;
        }

        .auxilio-card-text{
        width: 200px;
    }
        .faq-section{
            margin-top: 200px;
            margin-bottom: 0px;
            justify-content: center;
        }

        .faq-title{
            text-align: center;
        }
        .here{
            height: 10vh;
        }

        .preços{
            flex-direction: column;
            margin-top: 400px;
        }


    } 


</style>